import { render } from "./CreacionContadorView.vue?vue&type=template&id=06c0aa56"
import script from "./CreacionContadorView.vue?vue&type=script&lang=js"
export * from "./CreacionContadorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__